<template>
  <div class="xp-line" :class="[zsTjTheme]">
    <div class="title">
      <div class="text">XP评测</div>
    </div>
    <div ref="ellipsis" class="content" data-map-key="xpValue">
      <span @click="handleMore('XP评测', currentShowData.xpValue)" class="more">查看更多></span>
      <div
        class="ellipsis-3-lines"
        v-html="(currentShowData && simpleTextToHtml(getSplitString(currentShowData.xpValue))) || '-'"
      ></div>
    </div>
    <el-dialog
      title=""
      :custom-class="`more-drawer ${zsTjTheme}`"
      :visible.sync="drawer"
      :after-close="handleCloseMore"
      width="660px"
      append-to-body
    >
      <div class="more-content">
        <div class="header">
          <div class="title">{{ currentTitle }}</div>
          <div class="close" @click="handleCloseMore">
            <img src="@/assets/zs_imgs/close-icon.png" />
          </div>
        </div>
        <div class="content" v-html="simpleTextToHtml(currentContent)"></div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { simpleTextToHtml } from "@/plugins/util";

export default {
  props: {
    currentShowData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    currentShowStep: { type: Number, default: 0 }
  },
  data() {
    return {
      drawer: false,
      currentTitle: "",
      currentContent: ""
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme"])
  },
  watch: {
    currentShowStep: "setMoreVisible",
    currentShowData: {
      immediate: true,
      handler() {
        if (this.$isServer) return;
        this.setMoreVisible();
      }
    }
  },

  methods: {
    simpleTextToHtml,
    getSplitString(string) {
      return string;
    },
    handleMore(title, content) {
      this.currentTitle = title;
      // 将\n替换为<br>，并使用xss过滤器处理内容
      const formatText = content.replace(/\n/g, "<br>");
      this.currentContent = this.xss(formatText);
      this.drawer = true;
    },
    handleCloseMore() {
      this.drawer = false;
      this.currentTitle = "";
      this.currentContent = "";
    },
    setMoreVisible() {
      setTimeout(() => {
        const el = this.$refs.ellipsis;
        /** @type {HTMLDivElement} */
        const div = el.querySelector("div.ellipsis-3-lines");
        const more = el.querySelector("span.more");
        if (more) {
          if (div.scrollHeight <= div.clientHeight) {
            more.style.display = "none";
          } else {
            more.style.display = "block";
          }
        }
      }, 30);
    }
  }
};
</script>
<style lang="less" scoped>
.xp-line {
  flex: 0 0 auto;
  width: 100%;
  margin-bottom: 50px;
  .title {
    position: relative;
    width: 229px;
    height: 36px;
    margin-bottom: 9px;
    padding-left: 35px;
    box-sizing: border-box;
    line-height: 36px;
    background: url("~@/assets/zs_imgs/advice-title-bg.png") no-repeat;
    background-size: 100% 100%;
    .text {
      z-index: 1;
      font-weight: bold;
      font-size: 19px;
      color: #ffffff;
    }
    &::before {
      z-index: 1;
      content: "";
      position: absolute;
      top: 3px;
      left: 3px;
      width: 28px;
      height: 28px;
      background: url("~@/assets/zs_imgs/xp-title-icon.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .content {
    position: relative;
    font-weight: 500;
    font-size: 18px;
    color: #bbbbbb;
    line-height: 24px;
    .more {
      position: absolute;
      top: -36px;
      right: 0;
      font-weight: 500;
      font-size: 18px;
      color: #9df3ff;
      cursor: pointer;
    }
    .ellipsis-3-lines {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /* 限制显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.xp-line.light {
  .title {
    .text {
      color: #333333;
    }
    &::before {
      background: url("~@/assets/zs_imgs/light-xp-title-icon.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .content {
    color: #524b47;
    .more {
      color: #007fff;
    }
  }
}

/deep/ .more-drawer {
  background: transparent;
  box-shadow: none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .more-content {
    position: relative;
    height: 100%;
    // background: url("~@/assets/zs_imgs/dialog-bg.png") no-repeat;
    // background-size: 100% 100%;
    padding-top: 48px;
    background: linear-gradient(155deg, #262f3a 0%, #31415e 100%);
    border-radius: 16px;
    border: 2px solid rgba(61, 77, 99, 1);
    // border-image: linear-gradient(161deg, rgba(56, 61, 71, 1), rgba(61, 77, 99, 1)) 2 2;
    .header {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      height: 48px;
      line-height: 48px;
      padding-left: 16px;
      box-sizing: border-box;
      .title {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        // background: url("~@/assets/zs_imgs/dialog-title-bg.png") no-repeat;
        // background-size: 152px 38px;
        // width: 152px;
        height: 100%;
        line-height: 48px;
      }

      .close {
        position: absolute;
        right: 22px;
        top: 0;
        width: 12px;
        height: 12px;
        cursor: pointer;
        img {
          width: 100%;
        }
      }
    }

    .content {
      max-height: 576px;
      padding: 20px 16px 25px 16px;
      font-weight: 400;
      font-size: 17px;
      color: #fff;
      line-height: 25px;
      overflow: auto;
      box-sizing: border-box;
      background: rgba(120, 165, 211, 0.06);
    }
  }
}
/deep/ .more-drawer.light {
  .more-content {
    border: 1px solid #d1e3eb;
    background: linear-gradient(180deg, #effcff 0%, #ffffff 100%);
    .header {
      border-radius: 16px 16px 0 0;
      background-color: rgba(0, 0, 0, 0.15);
      .title {
        color: #333333;
      }
      .close {
        top: 50%;
        right: 22px;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          filter: brightness(0);
        }
      }
    }
    .content {
      color: #333333;
    }
  }
}
</style>
